import axios from 'axios';
import Cookie from '@/utils/cookie';
import { production } from '../config';
import md5 from 'js-md5';

// create an axios instance
const http = axios.create({
    baseURL: '/common-api/awclient',
    timeout: 30000, // request timeout
    responseType: "json",
    withCredentials: true,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    }
  });

http.interceptors.request.use(config => {
    var token = window.localStorage.getItem('token');
    if (!token) {
        token = Cookie.getCookie('token') || '';
    }
    if (token) {
        config.headers['token'] = token;
    }
    try {
      if (window.getAppInfo && window.getAppInfo.getAppInfo) {
        let ts = new Date().getTime();
        let appInfo = JSON.parse(window.getAppInfo.getAppInfo());
        let aid = appInfo['aid'] || '';
        let gaid = appInfo['gaid'] || '';
        let uid = appInfo['uid'];
        let code = appInfo['code'];
        let channel = appInfo['channel'];
        let commons = btoa(JSON.stringify({
          'aid': aid,
          'gaid': gaid,
          'uid': uid,
          'code': code,
          'channel': channel,
          'ts': ts,
        }));
        config.headers['wvc'] = commons;
        config.headers['x-req-ts'] = ts;
        config.headers['x-req-aid'] = aid;
        config.headers['x-req-gaid'] = gaid;
        config.headers['x-req-sign'] = md5(`aid=${aid}&gaid=${gaid}&ts=ts`);
      }
    } catch (e) {
      console.log(e);
    }
    if (!production) {
      config.url = config.url.replace('', '');
    }
    return config;
});

export default http;
